const regex = {
    EMAIL: /(?=^[_a-zA-Z0-9-]+(.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+\.(.[a-zA-Z0-9-]+)*[.a-zA-Z]{2,3}$)(?=^[^']*$)/,
    DATE: /^((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/[12]\d{3})$/,
    DATE_ISO: /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/,
    DATETIME: /^((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/[12]\d{3}) ((0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9])$/,
    DATETIME_ISO: /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))T((0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9])$/,
    LICENCE_PLATE: /^[a-zA-Z0-9]{7,}$/,
    PASSWORD: /^(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]).{8,}$/,
    TEL: /^0[0-9]{9}$/,
    AMOUNT: /^([0-9]\d*,)?\d+$/,
    FILE: /^(jpeg|gif|png|bmp|tiff|pdf)$/,
    ZIP_CODE: /^[0-9]{5}$/,
    LOYALTY_CARD: /^([A-Z0-9]{6})$/,
    ORB: 'BK/',
    NEPTING_OUTCOME: /^.*click-and-collect\/payment\/(success|error|cancelled|refused)\.html$/,
    URL_PARAMS: /[?&]+([^=&]+)=?([^&]*)?/gi,
    EXCLUDE_SPECIAL_CHARACTERS: /(?=^[^#@&«»(§!)°_><^¨$*€ù%`£,?;.:/=+"“”‘]*$)(?=(?!^\s+$)^.*$)/m
}

const COUPON_CODES = {
    FREE_HOT_DRINK: 'CHAUDBK',
    FREE_PRODUCT: 'CHAUDMA'
}

const messages = {
    OK: 'OK',
    REDIRECT_SIGNUP: 'REDIRECT_SIGNUP',
    WRONG_CREDENTIALS: 'WRONG_CREDENTIALS',
    EXPIRED_CREDENTIALS: 'EXPIRED_CREDENTIALS',
    MFA_REQUIRED: 'MFA_REQUIRED'
}

const errors = {
    ABUSIVE_ORDER: 'ABUSIVE_ORDER',
    ACCOUNT_INACTIVE: 'ACCOUNT_INACTIVE',
    ACTION_LOCKED: 'ACTION_LOCKED',
    ALREADY_VOTED: 'ALREADY_VOTED',
    BIRTHDATE_INVALID: 'BIRTHDATE_INVALID',
    CAKE_NOT_FOUND: 'CAKE_NOT_FOUND',
    CANDIDATE_ALREADY_ELECTED: 'CANDIDATE_ALREADY_ELECTED',
    CANDIDATE_NOT_FOUND: 'CANDIDATE_NOT_FOUND',
    CANNOT_CHANGE_EMAIL: 'CANNOT_CHANGE_EMAIL',
    CANNOT_PARSE_ARRIVAL_TIME: 'CANNOT_PARSE_ARRIVAL_TIME',
    CANNOT_PARSE_BIRTHDATE: 'CANNOT_PARSE_BIRTHDATE',
    CANNOT_PARSE_RESERVATION_DATE: 'CANNOT_PARSE_RESERVATION_DATE',
    CAC_CLOSED: 'CAC_CLOSED',
    CAC_PREPARATION_CLOSED: 'CAC_PREPARATION_CLOSED',
    CGU_NOT_ACCEPTED: 'CGU_NOT_ACCEPTED',
    CLIENT: 'CLIENT_ERROR',
    CODE_ALREADY_USED: 'CODE_ALREADY_USED',
    CODE_EXPIRED: 'CODE_EXPIRED',
    CODE_NOT_AVAILABLE: 'CODE_NOT_AVAILABLE',
    CODE_NOT_ELIGIBLE: 'CODE_NOT_ELIGIBLE',
    CODE_INVALID: 'CODE_INVALID',
    COUPON_ALREADY_GIVEN: 'COUPON_ALREADY_GIVEN',
    ECOMM_CATALOG_NOT_FOUND: 'CC_CATALOG_NOT_FOUND',
    ECOMM_ORDER_NOT_FOUND: 'CC_ORDER_NOT_FOUND',
    ECOMM_RESTAURANT_NOT_FOUND: 'CC_RESTAURANT_NOT_FOUND',
    ECOMM_USER_INFOS_NOT_FOUND: 'CC_USER_INFOS_NOT_FOUND',
    ELECTION_CLOSED: 'ELECTION_CLOSED',
    FEATURE_NOT_AVAILABLE: 'FEATURE_NOT_AVAILABLE',
    GIFT_NOT_FOUND: 'GIFT_NOT_FOUND',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    INVALID_ADDRESS: 'INVALID_ADDRESS',
    INVALID_CONTENT: 'INVALID_CONTENT',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    INVALID_EMAIL: 'INVALID_EMAIL',
    INVALID_PICKUP_TYPE: 'INVALID_PICKUP_TYPE',
    INVALID_RESPONSE: 'INVALID_RESPONSE',
    INVALID_TOKEN: 'INVALID_TOKEN',
    LACK_POINTS: 'LACK_POINTS',
    LOGIN_ALREADY_USED: 'LOGIN_ALREADY_USED',
    LOGIN_TYPE_INVALID: 'LOGIN_TYPE_INVALID',
    LOYALTY_NUMBER_ALREADY_USED: 'LOYALTY_NUMBER_ALREADY_USED',
    LOYALTY_NUMBER_INVALID: 'LOYALTY_NUMBER_INVALID',
    LOYALTY_NUMBER_WRONG_FORMAT: 'LOYALTY_NUMBER_WRONG_FORMAT',
    MAX_KIDS_REACHED: 'MAX_KIDS_REACHED',
    MISSING_PRODUCTS: 'MISSING_PRODUCTS',
    NETWORK: 'network',
    NO_CAPTCHA_TOKEN_PROVIDED: 'NO_CAPTCHA_TOKEN_PROVIDED',
    NOT_ALLOWED: 'NOT_ALLOWED',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
    NOT_FOUND: 'NOT_FOUND',
    OPERATION_INVALID_DATE: 'OPERATION_INVALID_DATE',
    OPERATION_INVALID_ORDER_TYPE: 'OPERATION_INVALID_ORDER_TYPE',
    OPERATION_INVALID_RESTAURANT: 'OPERATION_INVALID_RESTAURANT',
    OPERATION_NOT_AVAILABLE: 'OPERATION_NOT_AVAILABLE',
    OPERATION_TOTAL_LIMIT_REACHED: 'OPERATION_TOTAL_LIMIT_REACHED',
    OPERATION_USER_LIMIT_REACHED: 'OPERATION_USER_LIMIT_REACHED',
    OPERATION_USER_NOT_ELIGIBLE: 'OPERATION_USER_NOT_ELIGIBLE',
    OTHER: 'OTHER_ERROR',
    PAID_REJECTED: 'PAID_REJECTED',
    PARKING_CLOSED: 'PARKING_CLOSED',
    PASSWORDS_ARE_DIFFERENT: 'PASSWORDS_ARE_DIFFERENT',
    PASSWORD_WRONG_FORMAT: 'PASSWORD_WRONG_FORMAT',
    WRONG_CREDENTIALS: 'WRONG_CREDENTIALS',
    PAYMENT_REFUSED: 'PAYMENT_REFUSED',
    PAYMENT_ERROR: 'PAYMENT_ERROR',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    PHONE_WRONG_FORMAT: 'PHONE_WRONG_FORMAT',
    PRICE_DIFFERENCE: 'PRICE_DIFFERENCE',
    PRODUCT_NOT_AVAILABLE_IN_RESTAURANT: 'PRODUCT_NOT_AVAILABLE_IN_RESTAURANT',
    PROMO_NOT_FOUND: 'PROMO_NOT_FOUND',
    PROMOTION_NOT_VALID: 'PROMOTION_NOT_VALID',
    PROMOTION_NOT_AVAILABLE_IN_RESTAURANT:
        'PROMOTION_NOT_AVAILABLE_IN_RESTAURANT',
    REJECTED: 'REJECTED',
    RESERVATION_DATE_INVALID: 'RESERVATION_DATE_INVALID',
    RESTAURANT_ALREADY_FAVORITED: 'RESTAURANT_ALREADY_FAVORITED',
    RESTAURANT_CLOSED: 'RESTAURANT_CLOSED',
    RESTAURANT_NOT_FOUND: 'RESTAURANT_NOT_FOUND',
    SCAN_LIMIT_REACHED: 'SCAN_LIMIT_REACHED',
    SERVER: 'SERVER_ERROR',
    SERVICE_NOT_AVAILABLE_IN_RESTAURANT: 'SERVICE_NOT_AVAILABLE_IN_RESTAURANT',
    STUART_FAILURE: 'STUART_FAILURE',
    DELIVERY_PROVIDER_FAILURE: 'DELIVERY_PROVIDER_FAILURE',
    TABLE_ORDER_BAD_TOKEN: 'TABLE_ORDER_BAD_TOKEN',
    TIMEOUT: 'timeout',
    TOO_MUCH_CHARACTERS: 'TOO_MUCH_CHARACTERS',
    TOO_YOUNG: 'TOO_YOUNG',
    UID_ALREADY_USED: 'UID_ALREADY_USED',
    UNAVAILABLE_GAME: 'UNAVAILABLE_GAME',
    WRONG_OLD_PASSWORD: 'WRONG_OLD_PASSWORD',
    BAD_REQUEST: 'BAD_REQUEST',
    CLIENT_NOT_FOUND: 'CLIENT_NOT_FOUND',
    COUPON_NOT_AVAILABLE_IN_RESTAURANT: 'COUPON_NOT_AVAILABLE_IN_RESTAURANT',
    COUPON_ALREADY_USED: 'COUPON_ALREADY_USED',
    ALREADY_LOGGED: 'ALREADY_LOGGED',
    BADGE_ALREADY_EARNED: 'BADGE_ALREADY_EARNED',
    INVALID_STUDENT_EMAIL: 'INVALID_STUDENT_EMAIL',
    STUDENT_EMAIL_ALREADY_USED: 'STUDENT_EMAIL_ALREADY_USED',
    NOT_ELIGIBLE_FOR_STUDENT_BLASON: 'NOT_ELIGIBLE_FOR_STUDENT_BLASON',
    TOO_OLD_FOR_STUDENT: 'TOO_OLD_FOR_STUDENT',
    LEAP_YEAR_OPERATION_TOTAL_LIMIT_REACHED:
        'LEAP_YEAR_OPERATION_TOTAL_LIMIT_REACHED'
}

const restaurantStatus = {
    CLOSED: 'CLOSED',
    SOON: 'SOON',
    OPENED: 'OPENED',
    IMMINENT_OPENING: 'IMMINENT_OPENING',
    IMMINENT_CLOSING: 'IMMINENT_CLOSING'
}

const level = {
    NORMAL: 'NORMAL',
    BRONZE: 'BRONZE',
    SILVER: 'SILVER',
    GOLD: 'GOLD'
}

const authType = {
    APPLE: 'APPLE',
    CLASSIC: 'CLASSIC',
    FACEBOOK: 'FACEBOOK',
    GOOGLE: 'GOOGLE'
}

const couponStatus = {
    BURNED: 'BURNED',
    EXPIRED: 'EXPIRED',
    UNAVAILABLE: 'UNAVAILABLE',
    VALID: 'VALID'
}

const couponCategoryCode = {
    KINGDOM: 'KINGDOM',
    NOW: 'NOW'
}

const couponOrigin = {
    OPERATION_REPEAT_COUPON: 'OPERATION_REPEAT_COUPON',
    IMPERSONAL_COUPON: 'IMPERSONAL_COUPON',
    UNKNOWN: 'UNKNOWN',
    GENERIC_COUPON: 'GENERIC_COUPON',
    KINGDOM_POINTS: 'KINGDOM_POINTS',
    LOTTERY_OPERATION: 'LOTTERY_OPERATION',
    COUPON_MAIL: 'COUPON_MAIL'
}

const orderStatus = {
    DONE: 'DELIVERED',
    DISMISSED: 'DISMISSED',
    READY: 'READY_FOR_COLLECT',
    WAITING_FOR_PAYMENT: 'WAITING_FOR_PAYMENT',
    INPROGRESS: 'PREPARING',
    ACCEPTED: 'ACCEPTED',
    DEBITED: 'DEBITED',
    WAITING_RESPONSE: 'WAITING_FOR_RESPONSE'
}

const ecommOrderStatus = {
    BUILT: 'BUILT',
    MODIFIED: 'MODIFIED',
    VALIDATION_PENDING: 'VALIDATION_PENDING',
    REJECTED: 'REJECTED',
    MISSING_PRODUCT: 'MISSING_PRODUCT',
    VALIDATED: 'VALIDATED',
    PAYMENT_PENDING: 'PAYMENT_PENDING',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    PAYMENT_ERROR: 'PAYMENT_ERROR',
    PAYMENT_REFUSED: 'PAYMENT_REFUSED',
    PAID: 'PAID',
    STUART_ERROR: 'STUART_ERROR',
    STUART_JOB_PENDING: 'STUART_JOB_PENDING',
    STUART_JOB_VALIDATED: 'STUART_JOB_VALIDATED',
    DELIVERY_ERROR: 'DELIVERY_ERROR',
    DELIVERY_JOB_PENDING: 'DELIVERY_JOB_PENDING',
    DELIVERY_JOB_VALIDATED: 'DELIVERY_JOB_VALIDATED',
    PAID_VALIDATED: 'PAID_VALIDATED',
    USER_CANCELLED: 'USER_CANCELLED',
    SYSTEM_CANCELLED: 'SYSTEM_CANCELLED',
    PREPARATION_PENDING: 'PREPARATION_PENDING',
    PREPARED_NO_CALLBACK: 'PREPARED_NO_CALLBACK',
    DEBIT_PENDING: 'DEBIT_PENDING',
    DEBIT_ERROR: 'DEBIT_ERROR',
    DEBITED: 'DEBITED',
    FINALIZED: 'FINALIZED',
    NOT_CLICK_COLLECT: 'NOT_CLICK_COLLECT',
    REBOOT_ERROR: 'REBOOT_ERROR'
}

const promotionType = {
    ITEM_VALUE_FIXED: 'ITEM_VALUE_FIXED',
    ITEM_VALUE_DISCOUNT: 'ITEM_VALUE_DISCOUNT',
    ITEM_PERCENT_FIXED: 'ITEM_PERCENT_FIXED',
    ITEM_PERCENT_DISCOUNT: 'ITEM_PERCENT_DISCOUNT',
    ORDER_VALUE_FIXED: 'ORDER_VALUE_FIXED',
    ORDER_PERCENT_FIXED: 'ORDER_PERCENT_FIXED',
    ORDER_VALUE_DISCOUNT: 'ORDER_VALUE_DISCOUNT',
    ORDER_PERCENT_DISCOUNT: 'ORDER_PERCENT_DISCOUNT'
}

const paymentType = {
    CREDIT_CARD: 'Credit Card'
}

const promotionBeginningType = {
    ORDER: 'ORDER_',
    ITEM: 'ITEM_'
}

const deliveryServiceProvider = {
    STUART: '0',
    UBER: '1'
}

const restaurantServices = {
    BIRTHDAY: 'BIRTHDAY',
    BIRTHDAY_BOOKING: 'BIRTHDAY_BOOKING',
    CLICK_AND_COLLECT: 'CLICK_AND_COLLECT',
    CLICK_AND_COLLECT_DRIVE: 'CLICK_AND_COLLECT_DRIVE',
    CLICK_AND_COLLECT_ON_SITE: 'CLICK_AND_COLLECT_ON_SITE',
    CLICK_AND_COLLECT_PICKUP_PARKING: 'CLICK_AND_COLLECT_PICKUP_PARKING',
    DELIVEROO: 'DELIVERY_DELIVEROO',
    DELIVERY_IN_APP: 'DELIVERY_IN_APP',
    DRIVE: 'DRIVE',
    EXTERNAL_DELIVERY: 'DELIVERY',
    KINGDOM: 'KINGDOM',
    MEAL_VOUCHER: 'MEAL_VOUCHER',
    ON_SITE: 'ON_SITE',
    SERVICE_TABLE: 'TABLE_SERVICE',
    SERVICE_TABLE_INDOOR: 'TABLE_SERVICE_INDOOR',
    SERVICE_TABLE_OUTDOOR: 'TABLE_SERVICE_OUTDOOR',
    TABLE_ORDER: 'TABLE_ORDER',
    TABLE_ORDER_INDOOR: 'TABLE_ORDER_INDOOR',
    TABLE_ORDER_OUTDOOR: 'TABLE_ORDER_OUTDOOR',
    TAKEAWAY: 'TAKEAWAY',
    TERRACE: 'TERRACE',
    UBEREATS: 'DELIVERY_UBEREATS'
}

const orderPickUpType = {
    ONSITE: 'ON_SITE',
    TABLESERVICE: 'TABLE_SERVICE',
    TAKEAWAY: 'PICK_UP',
    DRIVE: 'DRIVE',
    PARKING: 'PARKING',
    DELIVERY_IN_APP: 'DELIVERY_IN_APP',
    TABLE_ORDER: 'TABLE_ORDER'
}

const ecommerceType = {
    CLICK_AND_COLLECT: 'CLICK_AND_COLLECT',
    DELIVERY_IN_APP: 'DELIVERY',
    TABLE_ORDER: 'TABLE_ORDER',
    EXTERNAL_DELIVERY: 'EXTERNAL_DELIVERY',
    CLICK_AND_COLLECT_DRIVE: 'CLICK_AND_COLLECT_DRIVE'
}

const PaymentProvider = {
    NEPTING: '0',
    ADYEN: '1'
}

const orderType = {
    CLASSIC: 'CLASSIC',
    CLICK_AND_COLLECT: 'CLICK&COLLECT'
}

const orderTaking = {
    APP: 'APP',
    COMPTOIR_DRIVE: 'COMPTOIR_DRIVE',
    KIOSK: 'KIOSK',
    WEB: 'WEB'
}

const featureCodes = {
    CLICK_AND_COLLECT: 'CLICK_AND_COLLECT',
    CLICK_AND_COLLECT_CUSTOMIZATION: 'CLICK_AND_COLLECT_CUSTOMIZATION',
    CLICK_AND_COLLECT_DELIVERY: 'CLICK_AND_COLLECT_DELIVERY',
    CLICK_AND_COLLECT_EXTRA: 'CLICK_AND_COLLECT_EXTRA',
    CLICK_AND_COLLECT_MAILING_LOCAUX: 'CLICK_AND_COLLECT_MAILING_LOCAUX',
    DELIVERY_IN_APP: 'DELIVERY_IN_APP',
    NATIONAL_STUDENT_BLAZON: 'NATIONAL_STUDENT_BLAZON',
    NATIONAL_STUDENT_BLAZON_KINGDOM: 'NATIONAL_STUDENT_BLAZON_KINGDOM',
    NATIONAL_STUDENT_BLAZON_REGISTRATION:
        'NATIONAL_STUDENT_BLAZON_REGISTRATION',
    DEV: 'DEV',
    KINGDOM_POINTS: 'KINGDOM_POINTS',
    GIVE_POINTS: 'GIVE_POINTS',
    STUDENT_BLAZON: 'STUDENT_BLAZON',
    LOTTERY: 'LOTTERY',
    BANNIERE_WEB_BURGER_MYSTERE: 'BANNIERE_WEB_BURGER_MYSTERE',
    BANNIERE_WEB_BK_DAYS: 'BANNIERE_WEB_BK_DAYS',
    BANNIERE_WEB_OPERATION_REPEAT: 'BANNIERE_WEB_OPERATION_REPEAT',
    BANNIERE_WEB_BAL_2_PROMO: 'BANNIERE_WEB_BAL_2_PROMO',
    PAID_SIDE_DISHES: 'PAID_SIDE_DISHES',
    TABLE_ORDER: 'TABLE_ORDER',
    WORKFLOW_ORDER_NOT_CONNECTED: 'WORKFLOW_ORDER_NOT_CONNECTED',
    TU_PREFERES_KING: 'TU_PREFERES_KING',
    ACTIVATION_ZENDESK_REDIRECTION: 'ACTIVATION_ZENDESK_REDIRECTION',
    AUTHENT: 'AUTHENT',
    AUTHENT_CLASSIC: 'AUTHENT_CLASSIC',
    AUTHENT_LOGIN_WITH_MFA: 'AUTHENT_LOGIN_WITH_MFA',
    AUTHENT_GOOGLE: 'AUTHENT_GOOGLE',
    AUTHENT_APPLE: 'AUTHENT_APPLE',
    AUTHENT_FACEBOOK: 'AUTHENT_FACEBOOK',
    ADYEN_APPLE_PAY: 'ADYEN_APPLE_PAY',
    ADYEN_GOOGLE_PAY: 'ADYEN_GOOGLE_PAY',
    ADYEN_APPLE_PAY_WEB: 'ADYEN_APPLE_PAY_WEB',
    ADYEN_GOOGLE_PAY_WEB: 'ADYEN_GOOGLE_PAY_WEB',
    ADYEN_ONE_CLICK: 'ADYEN_ONE_CLICK',
    NEPTING_ONE_CLICK_V1: 'NEPTING_ONE_CLICK_V1',
    NEPTING_ONE_CLICK_V2: 'NEPTING_ONE_CLICK_V2',
    MEAT_ORIGIN: 'MEAT_ORIGIN',
    LOTTERY_WHEEL: 'LOTTERY_WHEEL',
    LOTTERY_SCRATCH: 'LOTTERY_SCRATCH',
    OPTIN_PUSH: 'OPTIN_PUSH',
    FRANCHISED_RECLAMATION: 'FRANCHISED_RECLAMATION',
    TABLE_ORDER_FREE_HOT_DRINK: 'TABLE_ORDER_FREE_HOT_DRINK',
    LOTTERY_WHEEL_INSERT_KINGDOM_BACKGROUND_IMAGE:
        'LOTTERY_WHEEL_INSERT_KINGDOM_BACKGROUND_IMAGE',
    KINGDOM_MENU_BLAZON: 'KINGDOM_MENU_BLAZON',
    KING_BIRTHDAY: 'KING_BIRTHDAY',
    CONTACT_FORM: 'CONTACT_FORM',
    ENABLE_COOKIES_CONSENT: 'ENABLE_COOKIES_CONSENT',
    COMPANY_HISTORY: 'COMPANY_HISTORY',
    ENABLE_NEW_ORDER_FLOW: 'ENABLE_NEW_ORDER_FLOW',
    ENABLE_NEW_KINGDOM_ASSETS: 'ENABLE_NEW_KINGDOM_ASSETS'
}

const shouldDisplayTouchId = false

const catalogType = {
    CATEGORY: 'CATEGORY',
    MENU: 'MENU',
    PRODUCT: 'PRODUCT',
    PRODUCT_GROUP: 'PRODUCT_GROUP',
    GAME: 'GAME'
}

const promoType = {
    ...catalogType,
    ORDER: 'ORDER'
}

const promotionOriginType = {
    OPERATION_REPEAT_COUPON: 'OPERATION_REPEAT_COUPON',
    COMMON: 'COMMON',
    COUPON_MAIL: 'COUPON_MAIL',
    OTHER: 'OTHER'
}

const OPERATION_REPEAT_ATTRIBUTION_TYPE = {
    FIXED: 'FIXED',
    CHOICE: 'CHOICE',
    RANDOM: 'RANDOM'
}

const promotionEmailCouponType = {
    TPK: 'TPK'
}

const menuSize = {
    XL: 'XL',
    L: 'L',
    M: 'M',
    S: 'S'
}

const menuSizeName = {
    XL: 'EXTRA',
    L: 'KING SIZE',
    M: 'MEDIUM',
    S: 'SMALL'
}

const maxLength = {
    coupon: 20,
    BIRTHDAY_COMMENTS_LIMIT: 320
}

const recaptchaSiteKeyV2 = '6LfxHbQmAAAAAM-A27Q6OonAeAvKp8QEZi767pEm'
const recaptchaSiteKeyV3 = '6Lf5DqUUAAAAAIHKVINTlK4DGAisCEIXM75KeUqT'

const backgroundWhopper =
    'merci,votrecommandeabienetepriseencompte#jejoueautennis&TupeuxpasToast!@burritoking5console.log(Oups,uneerreurestsurvenue)'

const platformHeader = {
    APP_AND: 'APP_AND',
    APP_IOS: 'APP_IOS'
}

const queryParam = {
    MANAGE: 'manage',
    UPDATED_PLATFORM: 'updatedPlatform'
}

const transformations = {
    up: 'rotate(-90deg)',
    down: 'rotate(90deg)',
    left: 'rotate(180deg)',
    right: 'none'
}

const rewardTypes = {
    COUPON: 'COUPON',
    POINTS: 'POINTS',
    KINGDOM_POINTS: 'KINGDOM_POINTS',
    PROMOTION: 'PROMOTION',
    LOST: 'LOST'
}

const couponType = {
    FOOD: 'FOOD',
    DIGITAL: 'DIGITAL',
    PHYSICAL: 'PHYSICAL'
}

const ageCategories = [14, 19, 24, 29, 34, 49, 65]

const contentFormat = {
    CONTENT: 'content',
    SLIDER: 'slider',
    SUGGESTION: 'suggestion'
}

const neptingStatus = {
    PAYMENT_SUCCESS: 'PAYMENT_SUCCESS'
}

const customTimeout = {
    MERIM_TIMEOUT: 120000
}

const deliveryDriverStatus = {
    PENDING: 'PENDING',
    PICKING: 'PICKING',
    ALMOST_PICKING: 'ALMOST_PICKING',
    WAITING_AT_PICKUP: 'WAITING_AT_PICKUP',
    DELIVERING: 'DELIVERING',
    ALMOST_DELIVERING: 'ALMOST_DELIVERING',
    WAITING_AT_DROPOFF: 'WAITING_AT_DROPOFF',
    DELIVERED: 'DELIVERED',
    CANCELLED: 'CANCELLED'
}

const deliveryOrderJobStatus = {
    NEW: 'new',
    SCHEDULED: 'scheduled',
    SEARCHING: 'searching',
    IN_PROGRESS: 'in_progress',
    FINISHED: 'finished',
    CANCELLED: 'canceled',
    EXPIRED: 'expired',
    VOIDED: 'voided'
}

const deliveryCancelledOrderReasonKey = {
    UNREACHABLE_CUSTOMER: 'end-customer_unreachable',
    DUPLICATE_JOB: 'duplicate_job',
    CUSTOMER_CANCELLATION_REQUESTED: 'customer_cancellation_requested',
    PU_CLOSED: 'pu_closed',
    ADDRESS_ERROR: 'address_error',
    NO_SUPPLY: 'no_supply',
    WRONG_TRANSPORT_TYPE: 'wrong_transport_type',
    INCORRECT_PACKAGE: 'incorrect_package',
    TECHNICAL_ISSUE: 'technical_issue',
    COURIER_ISSUE: 'courier_issue',
    PACKAGE_NOT_READY: 'package_not_ready',
    PACKAGE_DAMAGED: 'package_damaged',
    OTHER: 'other',
    JOB_EXPIRED: 'job_expired'
}

const cannotPlayLotteryWithKingdomPointReasonKey = {
    DEVICE_ALREADY_USED: 'DEVICE_ALREADY_USED',
    MAX_RETRY_REACHED: 'MAX_RETRY_REACHED',
    NO_LOTTERY_AVAILABLE: 'NO_LOTTERY_AVAILABLE',
    NOT_ENOUGH_POINTS: 'NOT_ENOUGH_POINTS'
}

const paymentLogEvents = {
    NEPTING_PAYMENT_URL: 'NEPTING_PAYMENT_URL',
    NEPTING_PAYMENT: 'NEPTING_PAYMENT',
    NEPTING_PAYMENT_3DS_REQUIRED: 'NEPTING_PAYMENT_3DS_REQUIRED',
    NEPTING_WEBVIEW_PAYMENT_LOADED: 'NEPTING_WEBVIEW_PAYMENT_LOADED',
    NEPTING_WEBVIEW_CONFIRMATION_LOADED: 'NEPTING_WEBVIEW_CONFIRMATION_LOADED',
    NEPTING_WEBVIEW_EMPTY: 'NEPTING_WEBVIEW_EMPTY',
    NEPTING_WEBVIEW_PAYMENT_SUBMIT: 'NEPTING_WEBVIEW_PAYMENT_SUBMIT',
    NEPTING_WEBVIEW_PAYMENT_SUCCESS: 'NEPTING_WEBVIEW_PAYMENT_SUCCESS',
    NEPTING_WEBVIEW_PAYMENT_ERROR: 'NEPTING_WEBVIEW_PAYMENT_ERROR',
    NEPTING_WEBVIEW_PAYMENT_CANCELLED: 'NEPTING_WEBVIEW_PAYMENT_CANCELLED',
    NEPTING_ORDER_PAID: 'NEPTING_ORDER_PAID',
    NEPTING_ORDER_ERROR: 'NEPTING_ORDER_ERROR',
    NEPTING_ORDER_CANCELLED: 'NEPTING_ORDER_CANCELLED',
    NEPTING_WEBVIEW_HEADER_CLOSE: 'NEPTING_WEBVIEW_HEADER_CLOSE',
    NEPTING_WEBVIEW_CLOSE: 'NEPTING_WEBVIEW_CLOSE'
}

const easiwareThemes = {
    EASIWARE_DELIVERY_IN_APP: 'EASIWARE_DELIVERY_IN_APP'
}

const faqFormSubject = {
    KINGDOM_POINTS: 'KINGDOM_POINTS',
    OTHER: 'OTHER'
}

const adyenPaymentMethods = {
    APPLE_PAY: 'applepay',
    GOOGLE_PAY: 'googlepay',
    SCHEME: 'scheme'
}

const studentRegistrationStates = {
    NONE: 'NONE',
    DECLARED: 'DECLARED',
    VALIDATED: 'VALIDATED',
    OLD_LOCAL: 'OLD_LOCAL'
}

const restaurantEligibilityScope = {
    ALL: 'ALL',
    ONE: 'ONE',
    MULTIPLE: 'MULTIPLE'
}

const stuartErrors = {
    NO_DELIVERY_MAN: 'NO_DELIVERY_MAN',
    UNKNOWN: 'UNKNOWN'
}

const productFilters = {
    CIRCLE_VEGGIE: 'CIRCLE_VEGGIE',
    CIRCLE_BEEF: 'CIRCLE_BEEF',
    CIRCLE_CHICKEN: 'CIRCLE_CHICKEN',
    CIRCLE_FISH: 'CIRCLE_FISH',
    NO_BACON: 'NO_BACON',
    ICE: 'LES_GLACES',
    BAKERY: 'LES_PATISSERIES'
}

const categoryId = {
    DESSERTS: 'desserts',
    DRINKS: 'boissons',
    DRINKS_CC: 'boissons-cc',
    HOT_DRINKS: 'boissons-chaudes',
    SWEET_CORNER: 'sweet-corner'
}

const categoryTitle = {
    SAUCES: 'Sauces',
    DESSERTS: 'Desserts'
}

const lotteryGainType = {
    PROMOTION: 'PROMOTION',
    KINGDOM_POINTS: 'KINGDOM_POINTS',
    LOST: 'LOST'
}

const sender = {
    RESTAURANT: 'RESTAURANT',
    CLIENT: 'CLIENT'
}

const token = 'token'

const ingredientType = {
    NONE: 'NONE',
    ICE_CREAM: 'ICE_CREAM',
    GLAZING: 'GLAZING',
    TOPPING: 'TOPPING'
}

const CATEGORY_ID = {
    BLAZON: 'BLAZON'
}

export {
    PaymentProvider,
    adyenPaymentMethods,
    ageCategories,
    authType,
    backgroundWhopper,
    cannotPlayLotteryWithKingdomPointReasonKey,
    catalogType,
    contentFormat,
    couponCategoryCode,
    couponOrigin,
    couponStatus,
    couponType,
    customTimeout,
    deliveryCancelledOrderReasonKey,
    deliveryDriverStatus,
    deliveryOrderJobStatus,
    easiwareThemes,
    ecommOrderStatus,
    ecommerceType,
    errors,
    faqFormSubject,
    featureCodes,
    level,
    categoryId,
    maxLength,
    menuSize,
    menuSizeName,
    messages,
    neptingStatus,
    orderPickUpType,
    orderStatus,
    orderTaking,
    orderType,
    paymentLogEvents,
    paymentType,
    platformHeader,
    promoType,
    promotionBeginningType,
    promotionEmailCouponType,
    promotionOriginType,
    promotionType,
    queryParam,
    recaptchaSiteKeyV2,
    recaptchaSiteKeyV3,
    regex,
    restaurantServices,
    restaurantStatus,
    rewardTypes,
    shouldDisplayTouchId,
    transformations,
    studentRegistrationStates,
    restaurantEligibilityScope,
    stuartErrors,
    deliveryServiceProvider,
    productFilters,
    categoryTitle,
    lotteryGainType,
    sender,
    token,
    ingredientType,
    COUPON_CODES,
    OPERATION_REPEAT_ATTRIBUTION_TYPE,
    CATEGORY_ID
}
